import { DotLottiePlayer } from '@dotlottie/react-player';
import React, { useEffect, useRef } from 'react';
import { getJfsLoaderPath } from '../../../Utils/assetUtils';
import styles from './JFSNudgeAnalyzing.module.css';

const ANALYSING_TIMEOUT_MS = 5000;

type JFSNudgeAnalyzingProps = {
  onTimeout: () => void;
};

const JFSNudgeAnalyzing: React.FC<JFSNudgeAnalyzingProps> = ({ onTimeout }) => {
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    const timer = setTimeout(() => {
      onTimeoutRef.current();
    }, ANALYSING_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.overlay}>
      <DotLottiePlayer
        src={getJfsLoaderPath()}
        autoplay
        loop
        style={{ height: 64, width: 64 }}
      />

      <div className={styles.textContent}>
        <h2 className={styles.heading}>
          We&apos;re analysing your financial data
        </h2>
        <p className={styles.description}>
          Hang on a moment — we&apos;re putting together the insights from your
          accounts.
        </p>
      </div>
    </div>
  );
};

export default JFSNudgeAnalyzing;
